var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h16v16H0z","key":0}),React.createElement("g",{"fill":"#434343","key":1},[React.createElement("path",{"fillRule":"nonzero","d":"M13 11H3a1 1 0 0 1-1-1V2H0V0h3a1 1 0 0 1 1 1v1h11c.937 0 1.048.973.962 1.275l-2 7A1.001 1.001 0 0 1 13 11zM4 9h8.246l1.428-5H4v5z","key":0}),React.createElement("circle",{"cx":"3","cy":"14","r":"2","key":1}),React.createElement("circle",{"cx":"13","cy":"14","r":"2","key":2})])]));
}

Cart.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Cart;

Cart.default = Cart;
